<div class="page-content container">
  <div class="page-header">
    <h1>
      {{title1 }}
    </h1>
  </div>
  <div class="page-data shadow-sm">
    <div class="page-part">
      <div class="alert alert-info">
        <span><i class="fa fa-info-circle"></i> {{ title2}}</span>
      </div>
    </div>
    <div class="page-part" *ngIf="checkAddNew()">
      <div class="page-actions">
        <button class="btn btn-success" (click)="file.click()"><i class="fa fa-plus mr-1"></i> {{
          translationManager.getTranslation('Додаj нови документ') }}</button>
        <input type="file" id="file" accept="application/pdf,application/vnd.ms-excel, application/msword,
              application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/jpeg"
          (change)="handleFileInput($event)" #file style="display :none;">
      </div>
    </div>

    <div class="page-part">
      <div class="app-table-panel" app-table>
        <div class="app-table-used-filters">
          <div class="app-table-used-filters-title">
            <span>{{ translationManager.getTranslation('Искоришћени филтери') }}</span>
          </div>
          <div class="app-table-used-filter-items" search-tags>
            <div class="app-table-used-filter-items-no-content" search-tag-no-content>
              <span>{{ translationManager.getTranslation('Без искоришћених филтера') }}</span>
            </div>
            <div class="app-table-used-filter-item" style="display: none" search-tag-prototype>
              <span><i search-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                  search-tag-prototype-value></i></span>
              <a href="javascript:;" [title]="translationManager.getTranslation('Обрисати филтер') "
                search-tag-prototype-close>
                <i class="fas fa-times"></i>
              </a>
            </div>
            <div class="app-table-used-filter-item app-table-used-filter-item-order" style="display: none"
              order-tag-prototype>
              <span><i order-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                  order-tag-prototype-value></i></span>
              <a href="javascript:;" [title]="translationManager.getTranslation('Обрисати филтер')"
                order-tag-prototype-close>
                <i class="fas fa-times"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="app-table-filter-panel" filter>
          <div class="app-table-filter-icon">
            <a href="javascript:;" [title]="translationManager.getTranslation('Филтрирај ентитете') " filter-open>
              <i class="fas fa-filter"></i>
            </a>
          </div>
          <div class="app-table-filter">
            <div class="app-table-filter-search">
              <div class="app-table-filter-title">
                <span>{{ translationManager.getTranslation('Филтери') }}</span>
                <a href="javascript:;" [title]="translationManager.getTranslation('Затвори филтер') " filter-close>
                  <i class="fas fa-times"></i>
                </a>
              </div>
              <div class="page-part">
                <div class="alert alert-info">
                  <span><i class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Доступни филтери за
                    процес филтрирања података') }}</span>
                </div>
              </div>
              <div class="page-part">
                <div class="app-form-element">
                  <label>{{ translationManager.getTranslation('Назив') }}</label>
                  <div class="app-form-element-content">
                    <input type="text" search-input search-entity="Name"
                      [search-title-new]="translationManager.getTranslation('Назив')"
                      search-action="contains">
                  </div>
                </div>
              </div>
              <div class="app-form-element-buttons">
                <button class="btn btn-success" do-search><i class="fa fa-check mr-2"></i>{{
                  translationManager.getTranslation('Филтрирај') }}</button>
                <button class="btn btn-danger" reset-search><i class="fa fa-times mr-2"></i>{{
                  translationManager.getTranslation('Поништи') }}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="app-table">
          <table class="table table-striped text-dark-m1">
            <thead>
              <tr class="bgc-primary-tp2 text-white">
                <th>
                  <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по називу') " order
                    order-entity="Name">
                    {{ translationManager.getTranslation('Назив') }}
                  </a>
                </th>
                <th style="width: 100px" class="right">{{ translationManager.getTranslation('Акције') }}</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of items">
                <td>{{item.name}}</td>

                <td class="right">
                  <div class="table-actions">
                    <a *ngIf="checkDownload()" href="javascript:;"
                   (click)="downloadFile(item.id, item.name)"
                   [title]="translationManager.getTranslation('Преузми документ')" >
                    <i class="far fa-file"></i>
                   </a>
                    <a *ngIf="checkDelete()" href="javascript:;"
                      (click)="delete(item.id)" class="red" [title]="translationManager.getTranslation('Брисање')">
                      <i class="far fa-trash-alt"></i>
                    </a>

                  </div>
                </td>

              </tr>
            </tbody>
          </table>
          <div class="no-content" *ngIf="!items || items.length == 0">
            <span>{{ translationManager.getTranslation('Без података') }}</span>
          </div>
        </div>
        <div class="app-table-pagination">
          <div>
            <div pagination>
              <span>{{ translationManager.getTranslation('Страна') }}</span>
              <select pagination-pages>
                <option>1</option>
              </select>
              <span>{{ translationManager.getTranslation('од') }}</span>
              <span pagination-pages-count>-</span>
              <span class="app-table-pagination-arrows">
                <a href="javascript:;" [title]="translationManager.getTranslation('Иди на почетак')"
                  pagination-first-page>
                  <i class="fas fa-angle-double-left"></i>
                </a>
                <a href="javascript:;" [title]="translationManager.getTranslation('Претходна')"
                  pagination-previous-page>
                  <i class="fas fa-angle-left"></i>
                </a>
              </span>
              <span class="app-table-pagination-arrows">
                <a href="javascript:;" [title]="translationManager.getTranslation('Следећа')" pagination-next-page>
                  <i class="fas fa-angle-right"></i>
                </a>
                <a href="javascript:;" [title]="translationManager.getTranslation('Иди на крај')" pagination-last-page>
                  <i class="fas fa-angle-double-right"></i>
                </a>
              </span>
              <span>{{ translationManager.getTranslation('Број редова за приказ')}}</span>
              <select pagination-sizes>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
          <div class="app-table-pagination-sizes">
            <div>
              <span>{{ translationManager.getTranslation('Укупан број слогова') }}</span>
              <span pagination-total-count>-</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<modal-window #modalWindow [show]="showDeleteModal" [title]="translationManager.getTranslation('Брисање податка')">
  <div class="app-modal-content">
    <span>{{ translationManager.getTranslation('Да ли сте сигурни да желите да обришете податак ?') }}</span>
  </div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="deleteConfirmed()"><i class="fa fa-check mr-2"></i>{{
      translationManager.getTranslation('Да') }}</button>
    <button class="btn btn-warning" (click)="showDeleteModal = false"><i class="fa fa-times mr-2"></i>{{
      translationManager.getTranslation('Не') }}</button>
  </div>
</modal-window>
